import { render } from "./SearchResultsView.vue?vue&type=template&id=4c239084"
import script from "./SearchResultsView.vue?vue&type=script&lang=js"
export * from "./SearchResultsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__